import React from 'react';
import { useLocation } from 'react-router-dom';
import { parseQueryString } from 'Utils';

const useQueryParam = () => {
    const { search } = useLocation();
    const parsed = parseQueryString(search); // return key/val pairs or {}

    return React.useMemo(() => {
        return {
            parsed,
            search
        };
    }, [parsed, search]);
};

export { useQueryParam };
